import type { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpStatus } from '../enums/http-erors';
import { ToastMessageService } from '../services/toast-message.service';
import { StorageService } from '../services/storage.service';


export const errorInterceptor: HttpInterceptorFn = (req, next) => {

  let routerService = inject(Router);
  let toastMessageService = inject(ToastMessageService);
  let storageService = inject(StorageService);
  let errorMessage : any = "";
  
  return next(req).pipe(map(
    (event: HttpEvent<any>) => {
      return event;
    }
  ),
    catchError(
      (error: any) => {
        switch (error?.status || error?.error.status_code) {
          case HttpStatus.NetworkError:
            errorMessage = 'Network error. Please check your internet connection.';
            break;
          case HttpStatus.BadRequest:
            errorMessage = 'Bad Request. Please check your input.';
            break;
          case HttpStatus.NotFound:
            errorMessage = 'The requested resource was not found.';
            break;
          case HttpStatus.ServerError:
            errorMessage = 'Server error. Please try again later.';
            break;
          case HttpStatus.Unauthorized:
            errorMessage = 'Unauthorized access. Redirecting to login.';
            storageService.logout();
            routerService.navigate(['/login']);
            break;
          default:
            errorMessage = error?.error?.error;
            break;
        }
        toastMessageService.toastOnError('Error', errorMessage);
        return throwError(() => error);
      })
  );
};
